export default "__VITE_ASSET__tjanrs2i__"